export default __webpack_public_path__ + "static/maitai_2-32242592b5899545f2ce0f647f37dabd.mp4";